import { post } from "../api/api";

export const verifyCampaign = (campaignCode: string, idCardNo: string | null) => {
  return post({
    url: "/v1/partner/session/verify",
    params: { campaignCode, idCardNo },
  });
};
